// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from "vue";
import App from "./App";
import router from "./router";
import VueRouter from "vue-router";
import ElementUI from "element-ui";
import Directives from "./directives/index";
import VueQuillEditor from "vue-quill-editor";
// require styles 引入样式
// 下面三行必须要写
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";

import "element-ui/lib/theme-chalk/index.css";
import "./assets/style/global.css";
// 引用API文件
import store from "./store/index";
import base from "./base/base";
// import "../src/font-style/font.css"
import "@/utils/element-ui-bug-fixed";
const echarts = require("echarts");

Vue.prototype.$echarts = echarts;
// 将API方法绑定到全局

Vue.config.productionTip = false;

/* eslint-disable no-new */
Vue.use(ElementUI);
Vue.use(VueRouter);
Vue.use(base);
Vue.use(Directives);
Vue.use(VueQuillEditor);

new Vue({
  el: "#app",
  router,
  store,
  components: {
    App
  },
  template: "<App/>",
  render: h => h(App)
});



// WEBPACK FOOTER //
// ./src/main.js